<template>
    <div class="teamInt">
        <ValidationObserver class="centerx default-input" ref="form" v-slot="{handleSubmit}">
            <vs-row v-if="popupType !== 'editTeamIntegration'" vs-w="12">
                <vs-col vs-w="6" vs-sm="12">
                    <ValidationProvider
                        vid="advertiser_selected"
                        :name="$t('global.Advertiser')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <div class="p-2">
                            <label class="text-sm opacity-75">{{ $t('global.Advertiser') }}</label>
                            <v-select
                                :placeholder="$t('label.Choose_advertiser')"
                                :reduce="item => item.id"
                                label="name"
                                v-model="fields.advertiser"
                                :options="options.advertiser_list"
                                :clearable="false"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </div>
                    </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6" vs-sm="12">
                    <ValidationProvider
                        vid="model"
                        :name="$t('global.Model')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <div class="p-2">
                            <label class="text-sm opacity-75">{{ $t('global.Model') }}</label>
                            <v-select
                                :placeholder="$t('modals.Choose_model')"
                                v-model="fields.model"
                                :options="options.model_list"
                                :disabled="!Boolean(options.model_list.length)"
                                :clearable="false"
                                :reduce="item => item.id"
                                label="name"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </div>
                    </ValidationProvider>
                </vs-col>
            </vs-row>

            <vs-row v-if="popupType !== 'editTeamIntegration'" vs-w="12">
                <vs-col vs-w="6" vs-sm="12">
                    <ValidationProvider
                        vid="geo"
                        :name="$t('global.Geo')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <div class="p-2">
                            <label class="text-sm opacity-75">{{ $t('global.Geo') }}</label>
                            <v-select
                                :placeholder="$t('modals.Choose_geo')"
                                v-model="fields.geo"
                                :options="options.geo_list"
                                :disabled="!Boolean(options.geo_list.length)"
                                :clearable="false"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </div>
                    </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6" vs-sm="12">
                    <ValidationProvider
                        vid="integration"
                        :name="$t('global.Integration')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <div class="p-2">
                            <label class="text-sm opacity-75">{{ $t('global.Integration') }}</label>
                            <v-select
                                :placeholder="$t('label.Choose_integration')"
                                v-model="fields.integration"
                                :reduce="a => a.id"
                                label="name"
                                :options="options.integration_list"
                                :disabled="!Boolean(options.integration_list.length)"
                                :clearable="false"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </div>
                    </ValidationProvider>
                </vs-col>
            </vs-row>

            <vs-row vs-w="12">
                <vs-col vs-w="12">
                    <ValidationProvider
                        vid="countries"
                        :name="$t('global.Countries')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <div class="p-2">
                            <label class="text-sm opacity-75">{{ $t('global.Countries') }}</label>
                            <v-select
                                name="countries"
                                @option:selected="selecting"
                                @option:deselecting="deselectingCountry"
                                multiple
                                :closeOnSelect="false"
                                :placeholder="$t('modals.Choose_countries')"
                                v-model="fields.countries"
                                :options="options.countries_list"
                                :disabled="!Boolean(options.countries_list.length)"
                                :clearable="false"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </div>
                    </ValidationProvider>
                </vs-col>
                <vs-col vs-w="12">
                    <ValidationProvider
                        vid="offers"
                        :name="$t('global.Offers')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <div class="p-2">
                            <label class="text-sm opacity-75">{{ $t('global.Offers') }}</label>
                            <v-select
                                name="offers"
                                multiple
                                :closeOnSelect="false"
                                @option:selected="selecting"
                                @option:deselecting="deselectingOffer"
                                :placeholder="$t('modals.Choose_accepted_offers')"
                                v-model="fields.offers"
                                :options="options.offers_list"
                                :disabled="!Boolean(options.offers_list.length)"
                                :clearable="false"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </div>
                    </ValidationProvider>
                </vs-col>
            </vs-row>

            <!--Mas update-->
            <div v-if="payment.length" class="mt-4">
                <div class="flex justify-end">
                    <vs-button
                        @click="globalUpdateFn"
                        radius
                        color="primary"
                        type="filled"
                        v-bind="$iconData(!activeGlobal ? 'icon-chevron-down' : 'icon-plus', !activeGlobal ? 'fi-rs-angle-small-down' : 'fi-rr-plus')"
                        v-tooltip="!activeGlobal ? $t('global.globalUpdate') : $t('global.Save')"
                    ></vs-button>
                </div>
            </div>

            <!--Table-->
            <div class="p-2">
                <ds-table
                    v-if="payment.length"
                    :data="payment"
                    :heads="table.headers"
                    :max-items="payment.length"
                    :paginate="false"
                >
                    <template v-slot:country="{country}">
                        <div style="width: 50px">{{ country.country }}</div>
                    </template>

                    <template v-slot:offer="{offer}">
                        <div style="white-space: nowrap;">{{ offer.offer_name }}</div>
                    </template>

                    <template v-slot:external_price="{external_price}">
                        <ValidationProvider
                            :vid="createVId(external_price, 'external_price')"
                            rules="required|min:0|maxNum:100000|integer"
                            v-slot="{ errors }"
                            :name="$t('label.External_price')"
                        >
                            <div class="relative">
                                <vs-input
                                    :name="createVId(external_price, 'external_price')"
                                    type="number"
                                    min="0"
                                    class="inputx w-full no_focus"
                                    v-model="external_price.payout"
                                    @keypress="onKeypress($event, true)"
                                />

                                <vs-icon
                                    class="absolute errorPosition"
                                    v-if="errors.length"
                                    v-tooltip="errors[0]"
                                    size="small"
                                    color="red"
                                    v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')"
                                ></vs-icon>
                            </div>
                        </ValidationProvider>
                    </template>

                    <template v-slot:internal_price="{internal_price}">
                        <ValidationProvider
                            :vid="createVId(internal_price, 'internal_price')"
                            rules="required|min:0|maxNum:100000|integer"
                            v-slot="{ errors }"
                            :name="$t('label.Internal_price')"
                        >
                            <div class="relative">
                                <vs-input
                                    :name="createVId(internal_price, 'internal_price')"
                                    type="number"
                                    min="0"
                                    class="inputx w-full no_focus"
                                    v-model="internal_price.revenue"
                                    @keypress="onKeypress($event, true)"
                                />

                                <vs-icon
                                    class="absolute errorPosition"
                                    v-if="errors.length"
                                    v-tooltip="errors[0]"
                                    size="small"
                                    color="red"
                                    v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')"
                                ></vs-icon>
                            </div>
                        </ValidationProvider>
                    </template>

                    <template v-slot:percent="{percent}">
                        <ValidationProvider
                            :vid="createVId(percent, 'percent')"
                            rules="required|min:0|maxNum:100|floatOrInteger"
                            v-slot="{ errors }"
                            :name="$t('label.percent')"
                        >
                            <div class="relative">
                                <vs-input
                                    :name="createVId(percent, 'percent')"
                                    type="text"
                                    min="0"
                                    class="inputx w-full no_focus"
                                    v-model="percent.crg_percent"
                                    @keypress="onKeypress($event)"
                                />
                                <vs-icon
                                    class="absolute errorPosition"
                                    v-if="errors.length"
                                    v-tooltip="errors[0]"
                                    size="small"
                                    color="red"
                                    v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')"
                                ></vs-icon>
                            </div>
                        </ValidationProvider>
                    </template>

                    <template v-slot:low_priority="{low_priority}">
                        <div class="flex justify-center">
                            <vs-switch color="success" v-model="low_priority.is_low_priority"/>
                        </div>
                    </template>

                    <template v-slot:type="{type}">
                        <v-select
                            :name="createVId(type, 'crg_types')"
                            style="width: 200px;"
                            :placeholder="$t('global.Type')"
                            :reduce="item => item.id"
                            label="name"
                            appendToBody
                            v-model="type.crg_types"
                            :options="crgTypesOptions"
                            :clearable="true"
                            :calculate-position="withPopper"
                        />
                    </template>

                    <template v-slot:affiliates="{affiliates}">
                        <v-select multiple
                                  style="width: 350px;"
                                  :placeholder="$t('modals.Choose_affiliates')"
                                  :reduce="item => item.hash"
                                  label="name"
                                  appendToBody
                                  v-model="affiliates.affiliates"
                                  :options="affiliatesOptions"
                                  :clearable="false"
                                  :calculate-position="withPopper"
                                  :closeOnSelect="false"
                        />
                    </template>
                </ds-table>
            </div>

            <div class="p-2 flex flex-wrap items-center justify-between">
                <div></div>

                <vs-button :disabled="loading" @click.prevent="handleSubmit(submitForm)">{{
                        $t('buttons.Save')
                    }}
                </vs-button>
            </div>
        </ValidationObserver>

        <v-sidebar
            v-if="activeGlobal"
            :active="activeGlobal"
            width="350px"
            @close="closeSidebar"
        >
            <template #header>
                <div>{{$t('global.globalUpdate')}}</div>
            </template>

            <div>
                <label for="country">{{`${$t('global.Country')} (${$t('buttons.Filter')})`}}</label>
                <v-select
                    id="country"
                    name="country"
                    :reduce="item => item"
                    appendToBody
                    v-model="globalUpdateFilter.country"
                    :options="countryOptions"
                    :clearable="true"
                    :calculate-position="withPopper"
                />
            </div>

            <div class="mt-4">
                <label for="country">{{$t('label.Internal_price')}}</label>
                <div class="flex">
                    <vs-checkbox v-model="globalUpdateActive.revenue"></vs-checkbox>
                    <vs-input
                        :disabled="!globalUpdateActive.revenue"
                        name="internal_price"
                        type="number"
                        min="0"
                        class="inputx w-full no_focus"
                        v-model="globalUpdate.revenue"
                        @keypress="onKeypress($event, true)"
                    />
                </div>
            </div>

            <div class="mt-4">
                <label for="country">{{$t('label.External_price')}}</label>
                <div class="flex">
                    <vs-checkbox v-model="globalUpdateActive.payout"></vs-checkbox>
                    <vs-input
                        :disabled="!globalUpdateActive.payout"
                        name="external_price"
                        type="number"
                        min="0"
                        class="inputx w-full no_focus"
                        v-model="globalUpdate.payout"
                        @keypress="onKeypress($event, true)"
                    />
                </div>
            </div>

            <div class="mt-4">
                <label for="country">{{$t('label.percent')}}</label>
                <div class="flex">
                    <vs-checkbox v-model="globalUpdateActive.crg_percent"></vs-checkbox>
                    <vs-input
                        :disabled="!globalUpdateActive.crg_percent"
                        name="percent"
                        type="number"
                        min="0"
                        class="inputx w-full no_focus"
                        v-model="globalUpdate.crg_percent"
                        @keypress="onKeypress($event)"
                    />
                </div>
            </div>

            <div class="mt-4">
                <label for="country">{{$t('tooltip.cold_traffic')}}</label>
                <div class="flex">
                    <vs-checkbox v-model="globalUpdateActive.is_low_priority"></vs-checkbox>
                    <vs-switch
                        :disabled="!globalUpdateActive.is_low_priority"
                        color="success"
                        v-model="globalUpdate.is_low_priority"
                    />
                </div>
            </div>

            <div class="mt-4">
                <label for="country">{{$t('global.Type')}}</label>
                <div class="flex">
                    <vs-checkbox v-model="globalUpdateActive.crg_types"></vs-checkbox>
                    <v-select
                        class="w-full"
                        :disabled="!globalUpdateActive.crg_types"
                        name="crg_types"
                        :placeholder="$t('global.Type')"
                        :reduce="item => item.id"
                        label="name"
                        appendToBody
                        v-model="globalUpdate.crg_types"
                        :options="crgTypesOptions"
                        :clearable="true"
                        :calculate-position="withPopper"
                    />
                </div>
            </div>

            <div class="mt-4">
                <label for="country">{{$t('modals.Choose_affiliates')}}</label>
                <div class="flex">
                    <vs-checkbox v-model="globalUpdateActive.affiliates"></vs-checkbox>
                    <v-select
                        class="w-full"
                        :disabled="!globalUpdateActive.affiliates"
                        multiple
                        :placeholder="$t('modals.Choose_affiliates')"
                        :reduce="item => item.hash"
                        label="name"
                        appendToBody
                        v-model="globalUpdate.affiliates"
                        :options="affiliatesOptions"
                        :clearable="false"
                        :calculate-position="withPopper"
                        :closeOnSelect="false"
                    />
                </div>
            </div>

            <template #footer>
                <vs-button
                    @click="globalUpdateFn"
                    class="w-full"
                    color="primary"
                    type="filled"
                >{{$t('global.Save')}}</vs-button>
            </template>
        </v-sidebar>
    </div>
</template>

<script>
import vSelect from "vue-select"
import send from '@/utils/fetch'
import EventBus from "@/store/eventBus"
import ErrorHandler from "@/utils/errorHandler"
import {dateParse, vSelectPosition, utils} from '@/utils/mixins'
import Table from "@/components/table/Table.vue"
import VSidebar from "@/components/Sidebar.vue";

export default {
    props: ['popupData', 'popupType', 'popupButton'],

    mixins: [vSelectPosition, dateParse, utils],

    data() {
        return {
            loading: false,
            activeGlobal: false,
            scheduling_caps: [],
            days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
            daysOff: ['saturday', 'sunday'],
            globalUpdateFilter: {
                country: null,
            },
            globalUpdate: {
                payout: 0,
                revenue: 0,
                crg_percent: 0,
                affiliates: [],
                crg_types: null,
                is_low_priority: false
            },
            globalUpdateCopy: {},
            globalUpdateActive: {
                payout: false,
                revenue: false,
                is_low_priority: false,
                crg_percent: false,
                affiliates: false,
                crg_types: false
            },
            systemVariables: {
                advertisers: [],
                advertiserSelected: {},
                paymentTemplate: {
                    adv_teams_int_id: this.popupData.data ? this.popupData.data.id : null,
                    country: "",
                    offer_name: "",
                    payout: 0,
                    revenue: 0,
                    crg_percent: 0,
                    affiliates: []
                }
            },

            options: {
                advertiser_list: [],
                model_list: [],
                geo_list: [],
                integration_list: [],
                countries_list: [],
                offers_list: []
            },

            fields: {
                advertiser: '',
                model: '',
                geo: '',
                integration: '',
                countries: [],
                offers: [],
                team_id: null,
            },

            is_low_priority: false,

            payment: [],
            affiliatesOptions: [],
            crgTypesOptions: [],
            countryOptions: [],

            table: {
                headers: [
                    {name: 'global.Country', key: 'country', value: 'country', display: true},
                    {name: 'global.Offer', key: 'offer', value: 'offer', display: true},
                    {name: 'label.Internal_price', key: 'internal_price', value: 'internal_price', display: true},
                    {name: 'label.External_price', key: 'external_price', value: 'external_price', display: true},
                    {name: 'label.percent', key: 'percent', value: 'percent', display: true},
                    {name: 'tooltip.cold_traffic', key: 'low_priority', value: 'low_priority', display: true},
                    {name: 'global.Type', key: 'type', value: 'type', display: true},
                    {name: 'global.Affiliates', class: 'affiliate_width', key: 'affiliates', value: 'affiliates', display: true},
                ],
                data: []
            }
        }
    },

    components: {VSidebar, Table, vSelect},

    watch: {
        'fields.advertiser'(value) {
            if (this.popupType !== 'editTeamIntegration') {
                this._clearFields(['advertiser_list'])
            }
            this.systemVariables.advertiserSelected = this.systemVariables.advertisers.find(item => ~~item.id === ~~value)
            this.setModel()
        },

        'fields.model'() {
            if (this.popupType !== 'editTeamIntegration') {
                this._clearFields(['advertiser_list', 'model_list'])
            }
            this.setGeo()
        },

        'fields.geo'() {
            if (this.popupType !== 'editTeamIntegration') {
                this._clearFields(['advertiser_list', 'model_list', 'geo_list'])
            }
            this.setIntegration()
        },

        'fields.integration'() {
            if (this.popupType !== 'editTeamIntegration') {
                this._clearFields(['advertiser_list', 'model_list', 'geo_list', 'integration_list'])
            }
            this.setCountryAndOffer()
        },

        payment: {
            handler(value) {
                this.countryOptions = Array.from(new Set(value.map(item => item.country)))
            },
            immediate: true
        }
    },

    methods: {
        closeSidebar() {
            this.activeGlobal = false
        },

        globalUpdateFn() {
            if (this.activeGlobal) {
                this.submitGlobalData()
                this.activeGlobal = false
            } else {
                this.activeGlobal = true
            }
        },

        onKeypress(event, int = false) {
            const regex = int ? /^[0-9]$/ : /^[0-9.]$/
            if (!regex.test(event.key)) {
                event.preventDefault()
            }
        },

        createVId(obj, name) {
            return `${name}_${obj.country}_${obj.offer_name}`
        },

        _clearFields(exclude = []) {
            Object.keys(this.options).map(key => {
                if (!exclude.includes(key)) {
                    const fieldName = key.split('_')[0]
                    this.fields[fieldName] = Array.isArray(this.fields[fieldName]) ? [] : ''
                    this.options[key] = []
                }
            })
            this.payment = []
        },

        submitGlobalDataSetDefault() {
            Object.keys(this.globalUpdateActive).map(key => this.globalUpdateActive[key] = false)
            this.$set(this, 'globalUpdate', this.copy(this.globalUpdateCopy))
        },

        async submitGlobalData() {
            const activeKeys = Object.keys(this.globalUpdateActive).filter(key => this.globalUpdateActive[key])

            const update = Object.entries(this.globalUpdate).reduce((res, [key, value]) => {
                if (activeKeys.includes(key)) res[key] = value
                return res
            }, {})

            this.payment = this.payment.map(item => {
                const {country} = this.globalUpdateFilter

                if (country && item.country === country) {
                    Object.assign(item, update)
                }

                if (!country) {
                    Object.assign(item, update)
                }

                return item
            })

            this.submitGlobalDataSetDefault()
        },

        setModel() {
            const arr = []

            this.systemVariables.advertiserSelected.advertiser_integrations
                .map(item => {
                    if (!arr.some(a => a.id === item.traffic_model_id)) {
                        arr.push({
                            name: item.traffic_model.name,
                            id: item.traffic_model_id
                        })
                    }
                })

            this.options.model_list = arr
        },

        setGeo() {
            const list = this.systemVariables.advertiserSelected.advertiser_integrations
                .filter(item => item.traffic_model.id === this.fields.model)
                .map(item => item.geo.name)

            this.options.geo_list = Array.from(new Set(list))
        },

        setIntegration() {
            const list = this.systemVariables.advertiserSelected.advertiser_integrations
                .filter(item => item.traffic_model.id === this.fields.model && item.geo.name === this.fields.geo)
                .map(item => ({
                    name: item.name,
                    id: item.id
                }))

            this.options.integration_list = Array.from(new Set(list))
        },

        setCountryAndOffer() {
            const list = this.systemVariables.advertiserSelected.advertiser_integrations
                .find(item => item.traffic_model.id === this.fields.model &&
                    item.geo.name === this.fields.geo &&
                    item.id === this.fields.integration)

            if (list && Object.keys(list).length) {
                this.options.countries_list = list.countries || []
                this.options.offers_list = list.offers_accepted || []
            }
        },

        setAdvertisers(advertisers = []) {
            return advertisers.map(item => ({
                name: item.name,
                id: item.id
            }))
        },

        selecting() {
            if (this.fields.countries.length && this.fields.offers.length) {
                this.fields.countries.map(country => {
                    this.fields.offers.map(offer => {
                        const template = {...this.systemVariables.paymentTemplate}
                        template.country = country
                        template.offer_name = offer

                        const hasOffer = this.payment.find(item => item.country === country && item.offer_name === offer)
                        if (!hasOffer) {
                            this.payment.push(template)
                        }
                    })
                })
            }
        },

        deselectingCountry(name) {
            this.payment = this.payment.filter(item => item.country !== name)
        },

        deselectingOffer(name) {
            this.payment = this.payment.filter(item => item.offer_name !== name)
        },

        async submitForm() {
            try {
                this.loading = true
                const copyPayment = JSON.parse(JSON.stringify(this.payment))

                const advInt = this.systemVariables.advertiserSelected.advertiser_integrations
                    .find(item => item.id === this.fields.integration)

                const data = {
                    deals: copyPayment.map(item => {
                        item.crg_percent = (+item.crg_percent).toFixed(2)
                        item.advertiser_integration_id = this.popupData.advertiser_integration_id || advInt.id
                        item.team_id = this.fields.team_id
                        item.revenue_traffic_model_id = this.fields.model
                        item.payout_traffic_model_id = this.fields.model
                        item.revenue_crg_type_id = item.crg_types || null
                        item.payout_crg_type_id = item.crg_types || null
                        item.start_date = this.dateParse(new Date())
                        item.end_date = this.dateParse(new Date())
                        item.affiliate_hashes = item.affiliates
                        // item.is_active = item.hasOwnProperty('is_active') ? item.is_active : true
                        item.is_low_priority = item.is_low_priority || false

                        delete item.is_active

                        return item
                    })
                }

                if (this.popupType === 'createTeamIntegration') {
                    data.scheduling_caps = this.scheduling_caps.map(item => {
                        item.integration_id = this.popupData.advertiser_integration_id || advInt.id
                        item.team_id = this.fields.team_id
                        item.day = item.day.toLowerCase()

                        return item
                    })

                    await send(this.$url.advrtsr_team_integration.create, 'POST', {data})
                }

                if (this.popupType === 'editTeamIntegration') {
                    data.advertiser_integration_id = this.popupData.advertiser_integration_id || advInt.id
                    data.team_id = this.fields.team_id

                    await send(this.$url.advrtsr_team_integration.update, 'PUT', {data})
                }

                EventBus.$emit('getTeamsInt')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (e) {
                if (e.response) {
                    const response = e.response.data.result

                    if (response.errors) {
                        const err = response.errors['deals.0'][0]
                        if (err && /^Integration already added to team/.test(err)) {
                            this.$vs.notify({
                                title: this.$t('notification.error'),
                                text: err,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            })
                        }
                    }

                    if (response) {
                        this.$refs.form.setErrors(this.$errors(response))
                    }
                }
                new ErrorHandler(e).send
            } finally {
                this.loading = false
            }
        },

        async get() {
            try {
                const data = await send(this.$url.advrtsr_team_integration.deal_popup_data, 'GET', {
                    params: {team_id: this.popupData.id || this.popupData.currentTeamId}
                })
                    .then(response => response.data.result)

                this.options.advertiser_list = this.createNameById(this.setAdvertisers(data.advertisers))
                this.affiliatesOptions = data.users

                this.systemVariables.advertisers = data.advertisers
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getCrgType() {
            try {
                const response = await send(this.$url.deals.types, 'GET')
                    .then(response => response.data.result.crg_types)

                this.$nextTick(() => {
                    this.crgTypesOptions = response
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        copy(data) {
            return JSON.parse(JSON.stringify(data))
        },

        createSchedulingCaps() {
            this.scheduling_caps = this.days.map(day => (
                {
                    day,
                    cc_work_end: process.env.VUE_APP_WORK_END || '23:59',
                    cc_work_start: process.env.VUE_APP_WORK_START || '00:01',
                    is_active: !this.daysOff.includes(day),
                    leads: 0,
                    set: 0,
                    remainder: 0
                }
            ))
        }
    },

    async mounted() {
        try {
            this.globalUpdateCopy = this.copy(this.globalUpdate)
            this.createSchedulingCaps()
            await this.getCrgType()
            await this.get()

            this.fields.team_id = this.popupData.id || this.popupData.currentTeamId

            if (this.popupType === 'editTeamIntegration') {
                const popupData = this.copy(this.popupData.data)

                const offers = new Set()
                const countries = new Set()

                popupData.deals.map(item => {
                    countries.add(item.country)
                    offers.add(item.offer_name)
                })

                this.fields.advertiser = popupData.advertiser_id
                this.fields.model = popupData.traffic_model_id
                this.fields.geo = popupData.geo_name
                this.fields.integration = popupData.advertiser_integration_id
                this.fields.countries = Array.from(countries)
                this.fields.offers = Array.from(offers)

                this.payment = popupData.deals.map(item => {
                    item.crg_types = item.payout_crg_type ? item.payout_crg_type.id : null
                    item.affiliates = item.affiliates ? item.affiliates.map(aff => aff.hash) : []

                    return item
                })

                this.payment.forEach(payment => {
                    const data = popupData.deals
                        .find(item => item.country === payment.country && item.offer_name === payment.offer_name)

                    if (data) {
                        this.$set(payment, 'affId', data.id)
                    }

                    return payment
                })
            }
            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss" scoped>
.teamInt {
    .alignBlock {
        display: flex;
        align-items: center;
        justify-content: start;
        flex-direction: column;
    }

    table {
        th:nth-child(6) {
            text-align: center;

            > div {
                justify-content: center;

                .vs-table-text {
                    white-space: normal !important;
                    width: 140px;
                }
            }
        }
    }

    input[type='number'] {
        -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    .label {
        color: gray;
        font-size: 10px;
    }

    .errorPosition {
        right: -10px;
        top: -10px;
    }

    .no_focus {
        input {
            &:focus {
                box-shadow: none !important;
                border: 1px solid rgba(0, 0, 0, 0.2) !important;
            }
        }
    }

    .vs-table-text {
        white-space: nowrap;
    }

    .affiliate_width {
        .vs-table-text {
            width: 300px;
        }
    }
}
</style>
